<template>
  <div class="benefits">
    <el-row justify="center" class="persons-titles mt-5">
      <el-col align="center">
        <div v-html="data.beneficiosTexto"></div>
      </el-col>
    </el-row>

    <el-row justify="center" class="persons-titles">
      <el-col align="center">
        <h4>Benefícios</h4>
      </el-col>
    </el-row>

    <el-row justify="center" class="services mt-5">
      <el-col :span="24" align="center">
        <el-row justify="space-around">
          <el-col
            align="center"
            v-for="service in services"
            :span="5"
            :key="service.title"
            @click="selectDescription(service)"
          >
            <services-box :service="service" />
          </el-col>
        </el-row>
      </el-col>
    </el-row>

    <div class="close-btn-text mt-5 mb-5" @click="$emit('close-service')">Fechar</div>

    <el-dialog v-model="dialogVisible" width="70%" top="50px" class="dialogSection">
      <figure v-loading="isLoading">
        <img
          class="dialog-section-img"
          alt="Vue logo"
          :src="selectedDescription"
          @load="loaded"
        />
      </figure>
    </el-dialog>
  </div>
</template>

<script>
import { ref } from 'vue'
// import CardGreen from '@/components/cardGreen/CardGreen.vue'
import ServicesBox from '@/components/servicesBox/ServicesBox.vue'
// import axios from 'axios'
// import { firebaseRoutes } from '../../../config/firebase.conf'
export default {
  name: 'Benfits',
  components: {
    // CardGreen,
    ServicesBox
  },
  props: ['data'],
  async setup (props) {
    const selectedDescription = ref('')
    const openDescription = ref(false)
    const dialogVisible = ref(false)

    const isLoading = ref(true)
    const loaded = () => {
      isLoading.value = false
    }

    const services = ref([
      {
        image:
          'https://firebasestorage.googleapis.com/v0/b/pixeon-c-admin.appspot.com/o/persons%2Fbenefits%2FGrupo%202356.png?alt=media&token=dfc20158-bd85-452c-9818-2a0c77aab5c7',
        title: 'Saúde',
        desc: 'Saiba mais',
        name: 'saude',
        imageDescription: props.data.imgSaude
      },
      {
        image:
          'https://firebasestorage.googleapis.com/v0/b/pixeon-c-admin.appspot.com/o/persons%2Fbenefits%2FGrupo%202357.png?alt=media&token=fa29c852-8a69-4e69-b400-23f8f79121bf',
        title: 'Conforto Flexibilidade',
        desc: 'Saiba mais',
        name: 'conforto',
        imageDescription: props.data.imgConforto
      },
      {
        image:
          'https://firebasestorage.googleapis.com/v0/b/pixeon-c-admin.appspot.com/o/persons%2Fbenefits%2FGrupo%202355.png?alt=media&token=30dcb470-a9b6-4ee8-bcb8-21b8c709576b',
        title: 'Reconhecimento e Desenvolvimento',
        desc: 'Saiba mais',
        name: 'reconhecimento',
        imageDescription: props.data.imgReconhecimento
      },
      {
        image:
          'https://firebasestorage.googleapis.com/v0/b/pixeon-c-admin.appspot.com/o/persons%2Fbenefits%2FGrupo%202354.png?alt=media&token=e884957a-b3aa-4278-91c1-7fe041174eba',
        title: 'Facilidades',
        desc: 'Saiba mais',
        name: 'facilidades',
        imageDescription: props.data.imgFacilidades
      }
    ])

    const selectDescription = (desc) => {
      dialogVisible.value = true
      isLoading.value = true
      selectedDescription.value = desc.imageDescription
    }

    const openSection = (value, el) => {
      dialogVisible.value = true
    }
    return {
      services,
      // data,
      selectedDescription,
      selectDescription,
      openDescription,
      loaded,
      isLoading,
      openSection,
      dialogVisible
    }
  }
}
</script>
<style lang="scss">
@import "~@/styles/variables.scss";
.benefits {
  .persons-titles {
    h3,
    h4,
    span {
      color: $light-blue;
    }
  }

  .services {
    .service-box {
      cursor: pointer;
    }
  }
}

.service-description {
  margin-top: 5rem;
  img {
    width: 100%;
  }
}

.dialog-section-img {
  width: 100%
}
</style>
